var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"smile"},[_c('video',{ref:"video",attrs:{"loop":"","playsinline":"","muted":"","preload":"none"},domProps:{"muted":true}},[_c('source',{ref:"source",attrs:{"type":"video/mp4","poster":"../assets/smile-placeholder-m.jpg"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f665132","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Smile.vue
// module id = null
// module chunks = 